import { useQuery } from '@tanstack/react-query';
import { Divider } from '@zorro/design-system/v2/Divider';
import { ZorroLogo } from '@zorro/shared/assets';
import { Center, Group } from '@zorro/web/design-system';
import { callEndpoint, useImpersonation, useRoles } from '@zorro/web/ui-utils';

import { EmployerLogo } from '../../EmployerLogo';

export const AppLayoutHeaderMenuLogo = () => {
  const { user } = useImpersonation();
  const { isZorroOperations, isAgent } = useRoles();

  const isAuthenticated = Boolean(user);
  const tenantId = user?.tenantId;
  const { data: logoUrl } = useQuery({
    enabled: !isZorroOperations,
    queryKey: ['EmployerPublicInfo', isAuthenticated, isAgent, tenantId],
    queryFn: async () => {
      if (!tenantId) {
        return null;
      }

      if (isAgent) {
        const agency = await callEndpoint({
          method: 'agenciesControllerFindOne',
          params: [tenantId],
        });

        return agency?.logoUrl ?? null;
      }

      if (!isAuthenticated) {
        return null;
      }

      const employerPublicInfo = await callEndpoint({
        method: 'employersControllerFindEmployerPublicInfo',
        params: [tenantId],
      });

      return employerPublicInfo?.logoUrl ?? null;
    },
  });

  if (isZorroOperations) {
    return (
      <Group display={{ base: 'none', sm: 'inline-flex' }} wrap="nowrap">
        <Center px="0.25rem">
          <ZorroLogo variant="logo-only" />
        </Center>
        <Divider orientation="vertical" h={30} />
      </Group>
    );
  }

  if (logoUrl) {
    return (
      <Group display={{ base: 'none', sm: 'inline-flex' }} wrap="nowrap">
        <EmployerLogo h={24} w="min-content" logoUrl={logoUrl} />
        <Divider orientation="vertical" h={30} />
      </Group>
    );
  }

  return null;
};
